import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicCreerAjouterScore = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;
  
  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Gestion de votre compétition', link: '/topics/gestion-compet'},
    { label: "Général", link: '/topics/gestion-compet/general'}, 
    { label: topic.title, link: topic.link},
  ]

  // <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/app/dashboard`}>dashboard</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Depuis votre espace
              <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/app/dashboard`}>admin,</a> 
              cliquez sur l'onglet <strong>Scores.</strong>
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <p className="help-text mt-40">
              Pour saisir des scores, vous devez d'abord associer une catégorie avec un ou plusieurs WODs.
            </p>
            <div className="article-container mt-32" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Dans l'écran principale, la liste de toutes vos catégories s'affiche sous forme de boutons en haut de page. La catégorie sélectionnée est celle en noir.
              </p>
              <p className="help-text">
                Vous pouvez facilement passer d'une catégorie à une autre en cliquant simplement sur un bouton correspondant.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <p className="help-text">
                Dans la barre latérale secondaire, vous trouverez la liste de tous les WODs associés à la catégorie sélectionnée. 
              </p>
              <p className="help-text">
                Cochez simplement les WODs qui vous intéressent, et la liste des participants s’affichera automatiquement dans l’écran principal.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part">{anchorsParts[2].content}</p>
              <p className="help-text">
                Dans le tableau de saisie des scores, la première colonne affiche la liste des participants, tandis que les colonnes suivantes 
                correspondent aux WODs que vous avez sélectionnés.
              </p>
              <ul>
                <li className="pl-8 mb-24">
                  <p className="help-text mb-8">
                    <strong className="mr-8">Participants :</strong>
                    dans le tableau de saisie des scores, la première colonne affiche la liste des participants avec le nom de l'équipe et le club affilié. 
                    En cliquant sur un participant, vous pouvez voir les noms des athlètes qui composent l'équipe.
                  </p>
                  <p className="help-text mb-8">
                    Une barre de recherche, située dans la cellule tout en haut, permet de rechercher et filtrer rapidement un participant dans le tableau de saisie des scores.
                  </p>
                </li>
                <li className="pl-8 mb-24">
                  <p className="help-text mb-8">
                    <strong className="mr-8">WODs :</strong>
                    Le champ de saisie des scores est dynamique et n’affiche que les informations nécessaires, sans superflu. Pour un score basé sur un chrono, 
                    saisissez simplement les chiffres au format mm:ss:cc
                    <span className="fz-14 ml-8 op-9 fw-400">(par exemple, 13:28:56. Si les centièmes ne sont pas nécessaires, vous pouvez les omettre et inscrire simplement 13:28)</span>. 
                  </p>
                  <p className="help-text">
                    <i className="bi bi-info-circle fz-18 mr-8"></i>Si, dans le cas d'un For Time, votre athlète n'a pas terminé le WOD, cochez la case CAP. 
                    Cela remplira automatiquement le premier score avec la valeur du time cap. Et, si un athlète a terminé le WOD sous le Time Cap, 
                    il n'est pas necessaire de renseigner le 2e score Reps.
                  </p>
                </li>
              </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[3].ref}>
              <p className="help-title-part">{anchorsParts[3].content}</p>
              <p className="help-text">
                Si vous n'avez pas encore saisi le score d'un participant, le fond de sa ligne sera blanc, et les champs de saisie seront ouverts pour 
                vous permettre d'entrer les scores.
              </p>
              <p className="help-text">
                Une fois le champ renseigné, cliquez sur l'icône <i className="fa-solid fa-square-check fz-20 ml-8 mr-8 color-bleu"></i> pour enregistrer le score.
              </p>
              <p className="help-text">
                Dès que vous aurez enregistré un score, la ligne sera affichée avec un fond gris et les scores seront affichés sous forme de texte.
              </p>
              <p className="help-text">
                Pour modifier un score, cliquez sur l'icône&nbsp;&nbsp;<i className="fa-solid fa-pencil"></i>&nbsp;. &nbsp;Le formulaire de saisie s'ouvrira, saisissez le nouveau score, 
                puis enregistrez-le à nouveau.
              </p>
              <p className="help-text">
                Pour supprimer un score, cliquez sur l'icône&nbsp;&nbsp;<i className="fa-solid fa-trash-can"></i>&nbsp;. &nbsp;
                Confirmer ensuite la suppression du score.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicCreerAjouterScore 